<template>
  <span :class="style[className]">
    <span :class="style['spinner-dot']"></span>
    <span :class="style['spinner-dot']"></span>
    <span :class="style['spinner-dot']"></span>
  </span>
</template>

<script>
import style from './scss/_spinner.scss'

export default {
  data: () => ({ style }),
  props: {
    className: { type: String, default: 'spinner-chat-wrapper' }
  }
}
</script>
